module.exports = __webpack_public_path__ + "images/homepage-play-icon.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-play-icon.png
// module id = 856
// module chunks = 0